import type { Label } from '@@/packages/shared/types/models/label';

export type RawLabel = Omit<Label, 'scope'> & Partial<Pick<Label, 'scope'>>;

// Responses predate the scope field until the backend change deploys, and the backend defaults existing labels to supplier.
export function parseLabel(raw: RawLabel): Label {
  return { ...raw, scope: raw.scope ?? 'supplier' };
}
